<template>
    <div>
        <s-crud v-if="ShowVehicleApprovals !== null" title="Gestión de Vehículos" ref="gridVehicle" edit add
            :filter="filter" add-no-function searchInput sortable remove excel :config="config"
            @rowSelected="rowSelected($event)" @add="add()" @edit="edit()" @save="saveVeh($event)"
            height="calc(100dvh - 240px)">

            <!-- Filters Section -->
            <!-- <template v-slot:filter>
        <v-col class="" cols="12">
          <v-row>
            <v-col lg="4" md="6" sm="12" cols="12" style="display: relative;">
              <s-select-carriers autocomplete v-model="filter.SpcID" label="Transportista" @change="changecarrier"
                itemValue="SpcID" clearable :filterType="1" />
            </v-col>
          </v-row>
        </v-col>
      </template> -->

            <template v-slot:Audit="{ row }" v-if="ShowVehicleApprovals == 1">
                <v-btn color="primary" class="rounded-lg text-none" @click="openAuditModal(row)" small depressed>
                    Auditar
                </v-btn>
            </template>

            <template v-slot:VehPlate="{ row }">
                <div
                    class="font-mono font-black text-slate-950 text-sm tracking-tight bg-slate-100 px-2 py-1 rounded border w-fit shadow-sm">
                    {{ row.VehPlate }}</div>
            </template>

            <template v-slot:SpcDocument="{ row }">
                <div class="font-bold text-slate-900 truncate" :title="row.SpcCompanyName">{{ row.SpcCompanyName }}
                </div>
                <div class="text-[11px] font-mono text-slate-400 mt-0.5">RUC: {{ row.SpcDocument }}</div>
            </template>

            <template v-slot:VehEnsuredEnd="{ row }">
                <v-chip dark x-small :color="colorEnsuredr(row)" style="font-size:12px;">
                    {{ formatDateView(row.VehEnsuredEnd) || "Pendiente" }}
                </v-chip>
            </template>
            <template v-slot:VehPolicyEnd="{ row }">
                <v-chip dark x-small :color="colorPolicy(row)" style="font-size:12px;">
                    {{ formatDateView(row.VehPolicyEnd) || "Pendiente" }}
                </v-chip>
            </template>
            <template v-slot:VehTechnicalReviewEnd="{ row }">
                <v-chip dark x-small :color="colorTechnicalReview(row)" style="font-size:12px;">
                    {{ formatDateView(row.VehTechnicalReviewEnd) || "Pendiente" }}
                </v-chip>
            </template>
            <template v-slot:VehGpsEnd="{ row }">
                <v-chip dark x-small :color="colorGPS(row)" style="font-size:12px;">
                    {{ formatDateView(row.VehGpsEnd) || "Pendiente" }}
                </v-chip>
            </template>

            <template v-slot:VehStatus="{ row }">
                <span
                    :class="row.VehStatus == 2 ? 'bg-green-500 text-white' : (row.VehStatus == 3 ? 'bg-red-500 text-white' : 'bg-neutral-500 text-white')"
                    class="text-[9px] font-black px-2.5 py-1 rounded-md uppercase tracking-wider"
                    style="white-space: nowrap;">
                    {{ row.VehStatusText }}
                </span>
            </template>
        </s-crud>

        <v-dialog max-width="1200" v-model="dialog" persistent>
            <vehicle-edit :typeArea="typeArea" :areID="areID" @save="save()"
                @close="dialog = false; $refs.gridVehicle.refresh();" v-model="vehID" />
        </v-dialog>

        <!-- Modal de Auditoría -->
        <vehicle-audit v-model="auditDialog" :veh-id="vehID" @save="save()" @close="$refs.gridVehicle.refresh();" />
    </div>
</template>

<script>
import _sVehicle from "@/services/Management/VehicleService";
import vehicleEdit from "@/views/Management/Vehicle/VehicleEdit";
import vehicleAudit from "@/views/Management/Vehicle/VehicleAudit";
import SSelectCarriers from "../../../components/Utils/SSelectCarriers.vue";
import _sGenParam from "@/services/General/ParameterService";

export default {
    components: { vehicleEdit, vehicleAudit, SSelectCarriers },
    props: {
        typeArea: { type: Number, default: 1 }
    },
    data: () => ({
        areID: null,
        filter: {
            TypeArea: 1,
            SpcID: null,
            searchText: ''
        },

        selected: {},
        verificationDay: "",
        dialog: false,
        vehID: 0,
        auditDialog: false,
        ShowVehicleApprovals: null
    }),
    async created() {
        //this.filter.AreID= this.$fun.getUserInfo().CtrContract.AreID;
        try {
            const resp = await _sGenParam.search({ PrmName: "ShowVehicleApprovals" }, this.$fun.getUserID());
            this.ShowVehicleApprovals = resp && resp.data ? Number(resp.data.PrmValue) : 0;
            // console.log(JSON.parse(JSON.stringify({ ShowVehicleApprovals: this.ShowVehicleApprovals })))
        } catch (error) {
            console.error("Error loading ShowVehicleApprovals:", error);
            this.ShowVehicleApprovals = 0;
        }

        this.filter.TypeArea = this.typeArea

        this.verificationDay = this.moment()
            .add(15, "days")
            .format(this.$const.FormatDateMoment);
    },
    methods: {
        openAuditModal(row) {
            this.vehID = row.VehID;
            this.auditDialog = true;
        },
        formatDateView(value) {
            return this.$fun.formatDateView(value);
        },
        rowSelected(item) {
            this.selected = item;
            console.log(JSON.parse(JSON.stringify(this.selected)))
        },
        add() {
            this.dialog = true;
            console.log(this.dialog);
            // this.vehID = 0;
        },
        edit() {
            this.vehID = this.selected.length > 0 ? this.selected[0].VehID : 0;
            this.dialog = true;
        },
        save() {
            this.$refs.gridVehicle.refresh();
        },
        colorEnsuredr(item) {
            let color = "grey";
            if (item.VehEnsuredEnd != "" && item.VehEnsuredEnd != null) {
                if (this.verificationDay >= item.VehEnsuredEnd) color = "warning";
                else color = "success";
            }

            return color;
        },
        colorPolicy(item) {
            let color = "grey";
            if (item.VehPolicyEnd != "" && item.VehPolicyEnd != null) {
                if (this.verificationDay >= item.VehPolicyEnd) color = "warning";
                else color = "success";
            }

            return color;
        },
        colorTechnicalReview(item) {
            let color = "grey";
            if (item.VehTechnicalReviewEnd != "" && item.VehTechnicalReviewEnd != null) {
                if (this.verificationDay >= item.VehTechnicalReviewEnd) color = "warning";
                else color = "success";
            }

            return color;
        },
        colorGPS(item) {
            let color = "grey";
            if (item.VehGpsEnd != "" && item.VehGpsEnd != null) {
                if (this.verificationDay >= item.VehGpsEnd) color = "warning";
                else color = "success";
            }

            return color;
        },
        changecarrier: function (value) {
            this.filter.SpcID = value;
        }
    },
    computed: {
        config() {
            return {
                service: _sVehicle,
                model: {
                    VehID: "ID",
                    TypeVehicle: "int",
                    VehPlate: "string",
                    VehMotor: "string",
                    VehSerie: "string",
                    VehEnsuredEnd: "date",
                    VehPolicyEnd: "date",
                    VehTechnicalReviewEnd: "date",
                    VehGpsEnd: "date",
                    VehMileage: 0,
                    VehStatus: 1,
                },
                headers: this.headers,
            };
        },
        headers() {
            const list = [
                { text: "Estado", value: "VehStatus", align: "center", sortable: true, },
                { text: "Vehículo", value: "TypeVehicleText", sortable: true, },
                { text: "Tipo", value: "TypeVehicleText", width: "100" },
                { text: "Placa", value: "VehPlate", width: "100" },
                { text: "Transportista / Empresa", value: "SpcDocument", width: "200" },
                // { text: "Razon Social", value: "SpcCompanyName", width: 200 },
                { text: "Marca", value: "TypeBrandText", sortable: true, },
                { text: "Color", value: "TypeColorText", align: "center", },
                { text: "KM", value: "VehMileage", align: "center", },
                { text: "Constancia de Inscripción N°", value: "RegistrationConstancy", align: "end", width: 120 },
                { text: "SOAT", value: "VehEnsuredEnd", },
                { text: "Póliza", value: "VehPolicyEnd", },
                { text: "Rev Tca", value: "VehTechnicalReviewEnd", },
                { text: "GPS", value: "VehGpsEnd", },
            ];
            if (this.typeArea == 2) {
                list.splice(1, 1, {
                    text: "Tipo Veh.",
                    value: "TypeVehicleBrandName",
                    width: 60
                });
            }
            if (this.ShowVehicleApprovals == 0) {
                const estado = list.shift();
                list.push(estado);
            } else if (this.ShowVehicleApprovals == 1) {
                list.unshift({ text: "Auditar", value: "Audit", width: "120", align: "center", sortable: false });
            }
            return list;
        },
    }
}
</script>

<style scoped>
.gradient-primary {
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    /* background: linear-gradient(135deg, #f4c297 0%, #b75500 100%) */
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.search-field-header {
    padding: 8px;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 1rem;
    max-width: 250px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

/* @media (max-width:980px) { */
@media (max-width:768px) {
    .header-content {
        flex-direction: column;
    }

    .search-field-header {
        width: 100%;
        max-width: 80%;
    }
}

/* Tailwind CSS utility class mappings for custom table columns */
.font-bold {
    font-weight: 700;
}

.font-black {
    font-weight: 900;
}

.font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.text-slate-900 {
    color: #0f172a;
}

.text-slate-950 {
    color: #020617;
}

.text-slate-600 {
    color: #475569;
}

.text-slate-400 {
    color: #94a3b8;
}

.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.text-\[11px\] {
    font-size: 11px;
}

.text-\[9px\] {
    font-size: 9px;
}

.tracking-tight {
    letter-spacing: -0.025em;
}

.tracking-wider {
    letter-spacing: 0.05em;
}

.bg-slate-100 {
    background-color: #f1f5f9;
}

.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.rounded {
    border-radius: 0.25rem;
}

.rounded-lg {
    border-radius: 0.5rem !important;
}

.border {
    border: 1px solid #e2e8f0;
}

.w-fit {
    width: fit-content;
}

.shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.uppercase {
    text-transform: uppercase;
}

.mt-0\.5 {
    margin-top: 0.125rem;
}

.mt-1 {
    margin-top: 0.25rem;
}

.block {
    display: block;
}

.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Tailwind CSS classes for status column */
.bg-green-500 {
    background-color: #22c55e;
}

.bg-red-500 {
    background-color: #ef4444;
}

.bg-neutral-500 {
    background-color: #737373;
}

.text-white {
    color: #ffffff;
}

.px-2\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}

.rounded-md {
    border-radius: 0.375rem;
}
</style>
